/*───────────────────────────────────────────────────────────────
 📄 File: themeVariantColors.ts
 🧩 Description:
    Static color maps for dark/light theme variants.
    Extracted from store/theme.ts applyTheme function.
    Each variant defines: bg, card, border, sidebar hex colors.
────────────────────────────────────────────────────────────────*/

interface VariantColors { bg: string; card: string; border: string; sidebar: string; }

export const DARK_VARIANT_COLORS: Record<string, VariantColors> = {
    mint:            { bg: '#0f172a', card: '#1e293b', border: '#334155', sidebar: '#1e293b' },
    navy:            { bg: '#1e293b', card: '#334155', border: '#475569', sidebar: '#334155' },
    mirage:          { bg: '#0f1419', card: '#1a1f2e', border: '#2a3441', sidebar: '#1a1f2e' },
    cinder:          { bg: '#1c1c1c', card: '#2a2a2a', border: '#3a3a3a', sidebar: '#2a2a2a' },
    black:           { bg: '#000000', card: '#1a1a1a', border: '#2a2a2a', sidebar: '#1a1a1a' },
    'pure-black':    { bg: '#000000', card: '#141414', border: '#222222', sidebar: '#141414' },
    'dark-gray':     { bg: '#1e293b', card: '#334155', border: '#475569', sidebar: '#334155' },
    'very-dark-gray':{ bg: '#1a1a1a', card: '#262626', border: '#333333', sidebar: '#262626' },
};

export const LIGHT_VARIANT_COLORS: Record<string, VariantColors> = {
    slate:              { bg: '#f8fafc', card: '#ffffff', border: '#e2e8f0', sidebar: '#ffffff' },
    gray:               { bg: '#f9fafb', card: '#ffffff', border: '#e5e7eb', sidebar: '#ffffff' },
    neutral:            { bg: '#fafafa', card: '#ffffff', border: '#e5e5e5', sidebar: '#ffffff' },
    white:              { bg: '#ffffff', card: '#ffffff', border: '#e2e8f0', sidebar: '#ffffff' },
    'very-light-green': { bg: '#f0fdf4', card: '#ffffff', border: '#bbf7d0', sidebar: '#ffffff' },
    'very-light-purple':{ bg: '#faf5ff', card: '#ffffff', border: '#e9d5ff', sidebar: '#ffffff' },
    'light-green':      { bg: '#dcfce7', card: '#f0fdf4', border: '#86efac', sidebar: '#f0fdf4' },
};
